import React from "react";
import Breadcrumbs from "~/common/Breadcrumbs";
import LeafFooter from "./LeafFooter";
import LeafHeader from "./LeafHeader";
import PartsFilter from "../Sidebar/PartsFilter";
import PlusFilter from "../Sidebar/PlusFilter";
import ProductListing from "../ProductListing";
import QuickShipFilter from "../Sidebar/QuickShipFilter";
import SearchWithinFilter from "../Sidebar/SearchWithinFilter";
import SpecificationFilter from "../Sidebar/SpecificationFilter";
import VendorFilter from "../Sidebar/VendorFilter";
import { CategoryDetail } from "~/common/Store/models/Category";
import FeatureFlagProvider from "~/common/contexts/FeatureFlagProvider";

const LeafCategoryPage = (detail: CategoryDetail) => {
  return (
    <FeatureFlagProvider featureFlags={detail.featureFlags}>
      <Breadcrumbs breadcrumbs={detail.layoutConfiguration.breadCrumb.items} />
      <ProductListing
        {...{
          ...detail,
          aboveChromeComponent: <LeafHeader {...detail} />,
          belowPageComponent: <LeafFooter {...detail} />,
          filterComponentOrder: [
            PlusFilter,
            QuickShipFilter,
            VendorFilter,
            SpecificationFilter,
            PartsFilter,
            SearchWithinFilter,
          ],
          hasBackground: false,
          hasHeaderData: false,
          hideFilters: false,
          ignoreCategoryFacets: true,
          multiSelectTopper: detail.multiSelectTopper,
          pageName: detail.name,
          pageUrl: detail.link,
          promotedProductBrandAd: detail.brandAd,
          showCategoryFilter: false,
        }}
      />
    </FeatureFlagProvider>
  );
};

export default LeafCategoryPage;
